import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import MoreInfoSection from '@/sections/MoreInfo';
import { LINKS } from '@/constants/links';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import IconMobile from '@/assets/icons/heroIcons/Device-mobile.svg';
import IconUser from '@/assets/icons/heroIcons/User-group.svg';
import IconCoins from '@/assets/icons/heroIcons/Coins.svg';
function MoreInfo() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["whereToShop", "core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const isCsLanguage = useIsSelectedLanguage("cs");
  let t1;
  if ($[1] !== isCsLanguage || $[2] !== t) {
    t1 = <MoreInfoSection className="lg:pb-[6.5rem]" buttons={isCsLanguage ? [{
      analyticsParam: "whereToShopMoreInfoDeferredPayment",
      icon: <IconDeferredPayment className="fillButtonIcon" />,
      testId: "whereToShopMoreInfoDeferredPayment",
      title: t("core:products.deferredPayment"),
      to: LINKS().deferredPayment
    }, {
      analyticsParam: "whereToShopMoreInfoRevolvingApplication",
      icon: <IconMaxi className="fillButtonIcon" />,
      testId: "whereToShopMoreInfoRevolvingApplication",
      title: t("core:products.revolving"),
      to: LINKS().revolving
    }, {
      analyticsParam: "whereToShopMoreInfoPayInThree",
      icon: <IconThird className="fillButtonIcon" />,
      testId: "whereToShopMoreInfoPayInThree",
      title: t("core:link.payInThree"),
      to: LINKS().payInThree
    }, {
      analyticsParam: "whereToShopMoreInfoCard",
      icon: <IconCard className="fillButtonIcon" />,
      testId: "whereToShopMoreInfoCard",
      title: t("core:products.card"),
      to: LINKS().card
    }] : [{
      analyticsParam: "whereToShopMoreInfoPayInThree",
      icon: <IconThird className="fillButtonIcon" />,
      testId: "whereToShopMoreInfoPayInThree",
      title: t("core:products.payInThree"),
      to: LINKS().payInThree
    }, {
      analyticsParam: "payInThreeMorePricing",
      icon: <IconCoins className="fillButtonIcon" />,
      testId: "whereToShopMorePricing",
      title: t("core:products.pricing"),
      to: LINKS().pricing
    }, {
      analyticsParam: "whereToShopMobileApp",
      icon: <IconMobile className="fillButtonIcon" />,
      testId: "whereToShopMoreInfoMobileApp",
      title: t("core:products.mobileApp"),
      to: LINKS().mobileApp
    }, {
      analyticsParam: "whereToShopMoreInfoAboutCompany",
      icon: <IconUser className="fillButtonIcon" />,
      testId: "whereToShopMoreInfoAboutCompany",
      title: t("core:link.aboutUs"),
      to: LINKS().aboutCompany
    }]} />;
    $[1] = isCsLanguage;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export default MoreInfo;